import React from 'react';
import { SunIcon, MoonIcon } from "@heroicons/react/24/outline";
import { useSystemTheme } from '../hooks/useTheme.jsx';

const ThemeToggle = ({ className = '' }) => {
  const { theme, setTheme, effectiveTheme } = useSystemTheme();

  const themes = [
    { value: 'light', label: 'Light', icon: '☀️' },
    { value: 'dark', label: 'Dark', icon: '🌙' },
    { value: 'system', label: 'System', icon: '💻' }
  ];

  return (
    <div className={`relative ${className}`}>
      <div className="flex items-center space-x-1 bg-gray-100 dark:bg-gray-700 rounded-lg p-1">
        {themes.map((themeOption) => (
          <button
            key={themeOption.value}
            onClick={() => setTheme(themeOption.value)}
            className={`
              flex items-center space-x-1 px-3 py-1.5 rounded-md text-sm font-medium transition-all duration-200
              ${theme === themeOption.value
                ? 'bg-white dark:bg-gray-600 text-gray-900 dark:text-white shadow-sm'
                : 'text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white hover:bg-white/50 dark:hover:bg-gray-600/50'
              }
            `}
            title={`Switch to ${themeOption.label} theme`}
          >
            <span className="text-base">{themeOption.icon}</span>
            <span className="hidden sm:block">{themeOption.label}</span>
          </button>
        ))}
      </div>
      
      {/* Current effective theme indicator */}
      <div className="absolute -top-1 -right-1 w-3 h-3 rounded-full border-2 border-white dark:border-gray-800 bg-green-500 dark:bg-green-400" 
           title={`Currently using ${effectiveTheme} theme`}>
      </div>
    </div>
  );
};

// Simple theme toggle button (for mobile/compact spaces)
export const ThemeToggleButton = ({ className = '' }) => {
  const { effectiveTheme, setTheme } = useSystemTheme();

  const toggleTheme = () => {
    // Toggle between enhanced dark mode and light mode
    setTheme(effectiveTheme === 'dark' ? 'light' : 'dark');
  };

  return (
    <button
      onClick={toggleTheme}
      className={`
        p-2 rounded-lg transition-colors duration-200
        bg-gray-100 dark:bg-gray-700 
        text-gray-600 dark:text-gray-300 
        hover:bg-gray-200 dark:hover:bg-gray-600
        hover:text-gray-900 dark:hover:text-white
        ${className}
      `}
      title={`Switch to ${effectiveTheme === 'dark' ? 'light' : 'dark'} theme`}
    >
      {effectiveTheme === 'dark'
        ? <SunIcon className="h-5 w-5" />
        : <MoonIcon className="h-5 w-5" />}
    </button>
  );
};

export default ThemeToggle;
